module.exports = __webpack_public_path__ + "img/art6.3627e92e.png";